import React, { useState } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import Button from "@mui/material/Button";
import * as colors from "@mui/material/colors";
import { NearBy } from "./near-by";
import { Search } from "./search";
import { Direction } from "./direction";
import { ServiceArea } from "./service-area";
import { Drawer } from "../drawer/drawer";
import { AuthModal } from "../auth/auth-modal";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { logOut } from "../../store/auth/reducer";
import {  Menu, MenuItem,ListItemIcon, ListItemText  } from "@mui/material";
import AppleIcon from "@mui/icons-material/Apple";
import AndroidIcon from "@mui/icons-material/Android";

export const TopBar = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [collapsed, setCollapsed] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const { token } = useSelector((state) => state.auth);

  const toggleDrawer = () => {
    setIsDrawerOpen((prev) => !prev);
  };


  const toggleLogin = () => {
    setIsLoginOpen((prev) => !prev);
  };
 const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "start",
          padding: 2,
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: 1,
            transition: "0.5s ease-in-out",
            transform: collapsed ? "translateX(-487px)" : "translateX(0px)",
            width: "525px",
            zIndex: 10,
          }}
        >
          {props.activeTab === "SEARCH" && (
            <Search
              setActiveTab={(tab) => props.setActiveTab(tab)}
              toggleDrawer={toggleDrawer}
            />
          )}
          {props.activeTab === "NEAR_BY" && (
            <NearBy
              onClose={() => props.setActiveTab("SEARCH")}
              setActiveTab={(tab) => props.setActiveTab(tab)}
              toggleDrawer={toggleDrawer}
            />
          )}

          {props.activeTab === "DIRECTION" && (
            <Direction
              onClose={() => props.setActiveTab("SEARCH")}
              toggleDrawer={toggleDrawer}
              activeInnerTab={props.activeInnerTab}
              setActiveInnerTab={props.setActiveInnerTab}
              path_datas={props.path_datas}
              setPath_datas={props.setPath_datas}

            />
          )}

          {props.activeTab === "SERVICE_AREA" && (
            <ServiceArea
              onClose={() => props.setActiveTab("SEARCH")}
              setActiveTab={(tab) => props.setActiveTab(tab)}
              toggleDrawer={toggleDrawer}
            />
          )}

          <Box
            sx={{
              backgroundColor: colors.common.white,
              borderRadius: 1,
              boxShadow: 1,
              height: "48px",
            }}
          >
            <IconButton
              size="large"
              onClick={() => setCollapsed((prev) => !prev)}
            >
              {collapsed ? (
                <KeyboardDoubleArrowRightIcon />
              ) : (
                <KeyboardDoubleArrowLeftIcon />
              )}
            </IconButton>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: 2,
            zIndex: 10,
          }}
        >
      {/* Main Button */}
      <Button
        variant="contained"
        size="large"
        onClick={handleClick}
        sx={{
          backgroundColor: colors.common.white,
          color: colors.common.black,
          textTransform: "none",
          "&:hover": {
            backgroundColor: colors.common.white,
          },
        }}
      >
        {t("Get the App")}
      </Button>

      {/* Dropdown Menu */}
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        
         <MenuItem
          onClick={() => {
            window.open(
              "https://play.google.com/store/search?q=edas&c=apps",
              "_blank"
            );
            handleClose();
          }}
        >
          <ListItemIcon>
            <AndroidIcon color="success" />
          </ListItemIcon>
          <ListItemText>{t("Play Store")}</ListItemText>
        </MenuItem>

        {/* App Store */}
        <MenuItem
          onClick={() => {
            window.open(
              "https://apps.apple.com/us/app/edas/id6754965109",
              "_blank"
            );
            handleClose();
          }}
        >
          <ListItemIcon>
            <AppleIcon />
          </ListItemIcon>
          <ListItemText>{t("App Store")}</ListItemText>
        </MenuItem>

      </Menu>
    
          <Button
            variant="contained"
            size="large"
            sx={{
              backgroundColor: colors.common.white,
              color: colors.common.black,
              textTransform: "none",
              "&:hover": {
                backgroundColor: colors.common.white,
              },
            }}
            onClick={() => {
              if (token) {
                dispatch(logOut());
              } else {
                setIsLoginOpen(true);
              }
            }}
          >
            {token ? t('Logout') : t('Login')}
          </Button>
        </Box>
      </Box>
      <Drawer isOpen={isDrawerOpen} onClose={toggleDrawer} />
      <AuthModal isOpen={isLoginOpen} onClose={toggleLogin} />
    </>
  );
};
